/**
 * @generated SignedSource<<60592fabe2b464b3fec019801f30d147>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteTestUserInput = {
  testUserId: string;
};
export type DeleteTestUserPageMutation$variables = {
  input: DeleteTestUserInput;
};
export type DeleteTestUserPageMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type DeleteTestUserPageMutation = {
  response: DeleteTestUserPageMutation$data;
  variables: DeleteTestUserPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTestUserResponse",
    "kind": "LinkedField",
    "name": "deleteTestUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTestUserPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTestUserPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6398e0dd023621b28bbf8e34fd527452",
    "id": null,
    "metadata": {},
    "name": "DeleteTestUserPageMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTestUserPageMutation(\n  $input: DeleteTestUserInput!\n) {\n  response: deleteTestUser(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "645293df6643e82919656ec5ff315adc";

export default node;
